import { invert } from "lodash";

export enum AudienceEnum {
    AllCustomers = "all-customers",
    Subscribers = "subscribers",
    NewCustomers = "new-customers",
    InactiveCustomers = "inactive-customers",
    InactiveCustomersSevenDays = "inactive-customers-7-days",
    InactiveCustomersSFourteenDays = "inactive-customers-14-days",
    InactiveCustomersThirtyDays = "inactive-customers-30-days",
    InactiveCustomersFortyFiveDays = "inactive-customers-45-days",
    InactiveCustomersSixtyDays = "inactive-customers-60-days",
    Students = "students",
    ReturningCustomers = "returning-customers",
    ReturningCustomersSixMonths = "returning-customers-6-months",
}

// TODO: A supprimer une fois toutes les audiences migrées en enums
export const AUDIENCE_ENUM_TO_ID_MAP: Record<AudienceEnum, number> = {
    [AudienceEnum.AllCustomers]: 1,
    [AudienceEnum.Subscribers]: 2,
    [AudienceEnum.NewCustomers]: 3,
    [AudienceEnum.InactiveCustomers]: 4,
    [AudienceEnum.InactiveCustomersSevenDays]: 5,
    [AudienceEnum.InactiveCustomersSFourteenDays]: 6,
    [AudienceEnum.InactiveCustomersThirtyDays]: 7,
    [AudienceEnum.InactiveCustomersFortyFiveDays]: 8,
    [AudienceEnum.InactiveCustomersSixtyDays]: 9,
    [AudienceEnum.Students]: 10,
    [AudienceEnum.ReturningCustomersSixMonths]: 11,
    [AudienceEnum.ReturningCustomers]: 12,
};

export const AUDIENCE_ID_TO_ENUM_MAP = invert(AUDIENCE_ENUM_TO_ID_MAP) as Record<
    string,
    AudienceEnum
>;
